// Remembers the page a logged-out user tried to open so login can send them back to it.
// sessionStorage is used because ProtectedRoute wipes localStorage on logout.
const KEY = 'postLoginRedirect';

// Only same-app paths, never protocol-relative (//evil.com) or absolute URLs
const isSafePath = (path) => typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');

export const savePostLoginRedirect = (path) => {
  if (!isSafePath(path) || path === '/') return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch (e) {
    // storage unavailable; login falls back to the default landing page
  }
};

export const consumePostLoginRedirect = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return isSafePath(path) ? path : null;
  } catch (e) {
    return null;
  }
};
